import { cn } from '@/lib/shadcn/utils';
import { ShortlistCandidateCardSkeleton } from '@/modules/public-shortlist/components/ShortlistCandidateCardSkeleton';
import { ShortlistHeader } from '@/modules/public-shortlist/components/ShortlistHeader';
import {
  FEATURED_CANDIDATE_COUNT,
  SHORTLIST_MAX_WIDTH_CLASS,
} from '@/modules/public-shortlist/constants';
import { Skeleton } from '@/modules/ui/components/skeleton/Skeleton';

export function ShortlistPageSkeleton() {
  return (
    <div className="bg-neutral-120 flex min-h-screen flex-col">
      <ShortlistHeader
        onCtaClick={() => {}}
        showCta
        contentClassName={SHORTLIST_MAX_WIDTH_CLASS}
      />

      <main className="flex-1">
        <div
          className={cn(
            'mx-auto w-full px-4 py-10 sm:px-6 md:py-14 lg:px-8',
            SHORTLIST_MAX_WIDTH_CLASS,
          )}
        >
          <header className="space-y-3">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-10 w-full max-w-lg" />
            <Skeleton className="h-4 w-full max-w-md" />
          </header>

          <div
            className="mt-8 space-y-5 md:space-y-6"
            aria-busy
            aria-label="Loading candidates"
          >
            {Array.from({ length: FEATURED_CANDIDATE_COUNT }).map(
              (_, index) => (
                <ShortlistCandidateCardSkeleton
                  key={`candidate-skeleton-${index}`}
                />
              ),
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
